import { createSelector } from '@reduxjs/toolkit';

import { selectResults } from './results';
import { selectBreadcrumbs } from './selectBreadcrumbs';
import { getUser } from './user';
import { prepareTrackingData } from '../utils/prepareTrackingData';

export const getTrackingData = createSelector(selectResults, getUser, selectBreadcrumbs, (results, user, breadcrumbs) =>
  prepareTrackingData(results, breadcrumbs, user),
);
